import { Helmet } from 'react-helmet-async';

type Props = {
  title: string;
  description?: string;
  // path?: string;
};

export const HeadBlock: React.VFC<Props> = (props) => {
  const { title, description, /*path*/ } = props;
  return (
    <Helmet>
      <title>{title !== "" ? title : "デジタルDMOプラットフォーム"}</title>
      <meta name="description" content={description ?? "デジタルDMOプラットフォーム"} />
      {/* <link rel="canonical" href={`https:hoge.com/${path ?? ''}`} /> */}
      {/* <meta name="viewport" content="width=device-width, initial-scale=1.0" /> */}
    </Helmet>
  );
};